<template>
  <div class="app-container">
    <list ref="list" :can-price="canPrice">
      <template slot="toolbar-right" v-if="canWrite">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="info" @click="onPrintTemaplate">打印模板</el-button>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="{row}">
            <!-- <el-button v-if="canWrite && row.Status !== 2" @click="edit(row)" type="text">编辑</el-button> -->
            <el-button type="text" @click="edit(row)">查看</el-button>
            <el-button v-if="row.Status == 1" v-show="canWrite" type="text" @click="onFinished(row,1)">完结</el-button>
            <el-button v-if="row.Status == 2" v-show="canWrite" type="text" @click="onFinished(row,2)">取消完结</el-button>
            <!-- <el-button type="text" @click="onPrint(row)">打印</el-button> -->
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/ticketmanagement/dispatch/list'


export default {
  name: "dispatch",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/pr/PrDispatchDoc").default,
    }
  },
  mounted() {
  },
  computed: {
    canWrite() {
      return this.$permission.canWrite();
    },
    canPrice() {
      return this.$permission.canPrice();
    },
    canReview() {
      return this.$permission.canReview();
    },
  },
  methods: {
    edit(row) {
      let id = row.DocId;
      this.api.info(id).then(res => {
        if (res.Code === 0) {
          this.toURL({ name: 'editdispatch', params: { type: 'edit', data: res.Data } });
        }
      })
    },
    create() {
      this.toURL({
        name: 'editdispatch',
        params: { type: 'create' }
      })
    },
    toURL(o) {
      this.$router.push(o)
    },
    onPrintTemaplate() {
      var url = location.origin + "/#/customprint/" + "派工单";
      window.open(url, "_blank");
    },
    onPrint(row) {
      var url = location.origin + "/#/customprintview/派工单/" + row.DocId;
      window.open(url, "_blank");
    },
    onFinished(row) {
      const ids = [row.DocId]
      this.api.updateStatus(ids).then((res) => {
        if (res.Code === 0) {
          this.$message.success("操作成功");
          this.reload();
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.export(this.$refs.list.$refs.list.queryParams).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
    },
  }
};
</script>